// Permet de renvoyer une date Heure au format AAAA-MM-JJ HH:II:SS en JJ/MM/AAAA HH:II
// Exemple : 2021-12-25 10:25:03 en 25/12/2021 10:25
export function toDateTimeFR(dateTime) {
  if (dateTime) {
    var date = dateTime.split(" ")[0];
    var time = dateTime.split(" ")[1];

    var annee = date.split("-")[0];
    var mois = date.split("-")[1];
    var jour = date.split("-")[2];
    var heures = time.split(":")[0];
    var minutes = time.split(":")[1];

    return jour + "/" + mois + "/" + annee + " à " + heures + ":" + minutes;
  } else return "00/00/0000 à 00:00";
}

// Permet de renvoyer une date Heure au format AAAA-MM-JJ HH:II:SS en JJ/MM/AAAA HH:II
// Exemple : 2021-12-25 en 25/12/2021
export function toDateFR(date) {
  if (date) {
    var annee = date.split("-")[0];
    var mois = date.split("-")[1];
    var jour = date.split("-")[2];

    return jour + "/" + mois + "/" + annee;
  } else return "00/00/0000";
}

// Permet de renvoyer une date  au format AAAA-MM-JJT00:00:00.000+00:00 et JJ/MM/AAAA
// Exemple : 2013-12-22T00:00:00.000+00:00 en 22/12/2013
export function toDateParseFR(dateParse) {
  if (dateParse) {
    var date = dateParse.split("T")[0];

    var annee = date.split("-")[0];
    var mois = date.split("-")[1];
    var jour = date.split("-")[2];

    return jour + "/" + mois + "/" + annee;
  } else return "00/00/0000";
}

// Permet de renvoyer une date  au format AAAA-MM-JJT00:00:00.000+00:00 et AAAA-MM-JJ
// Exemple : 2013-12-22T00:00:00.000+00:00 en 2013-12-22
export function toDateParseEN(dateParse) {
  if (dateParse) {
    var date = dateParse.split("T")[0];

    var annee = date.split("-")[0];
    var mois = date.split("-")[1];
    var jour = date.split("-")[2];

    return annee + "-" + mois + "-" + jour;
  } else return "0000-00-00";
}

// Permet de renvoyer une date  au format AAAA-MM-JJT00:00:00.000+00:00 en AAAAMMJJ
// Exemple : 2013-12-22T00:00:00.000+00:00 en 20131222
export function toDateParseTCompact(dateParse) {
  if (dateParse) {
    var date = dateParse.split("T")[0];

    var annee = date.split("-")[0];
    var mois = date.split("-")[1];
    var jour = date.split("-")[2];

    return annee + mois + jour;
  } else return "00000000";
}

// Permet de renvoyer une date Heure au format AAAA-MM-JJ HH:II:SS en en AAAAMMJJ
// Exemple : 2021-12-25 10:25:03 en 20211225
export function toDateTimeCompact(dateTime) {
  if (dateTime) {
    var date = dateTime.split(" ")[0];

    var annee = date.split("-")[0];
    var mois = date.split("-")[1];
    var jour = date.split("-")[2];

    return annee + mois + jour;
  } else return "00000000";
}

// Permet de renvoyer une date au format JJ/MM/AAAA en en AAAAMMJJ
// Exemple : 2021-12-25 en 20211225
export function toDateCompactFR(date) {
  if (date) {
    date = date.replace(/ /g, "");
    var jour = date.split("/")[0];
    var mois = date.split("/")[1];
    var annee = date.split("/")[2];

    return annee + mois + jour;
  } else return "00000000";
}

/* Permet de renvoyer si une date A est plus petite que une date B */
export function compareDates(date1, date2) {
  var dateA = new Date(date1);
  var dateB = new Date(date2);
  if (dateA < dateB) return true;

  return false;
}

// permet de rencoyer la date du jour en cours au format AAAA-MM-JJ
export function dateJour() {
  var futureDate = new Date();
  var finalDate =
    futureDate.getFullYear() +
    "-" +
    (futureDate.getMonth() + 1 < 10 ? "0" : "") +
    (futureDate.getMonth() + 1) +
    "-" +
    (futureDate.getDate() < 10 ? "0" : "") +
    futureDate.getDate();

  return finalDate;
}

// Permet de calculer l'écart entre 2 dates au format AAAA-MM-JJ
// retourne une variable diff qui peut récupérer les valeurs suivantes: diff.day diff.hour diff.min diff.sec
export function dateDiff(date1, date2) {
  date1 = new Date(date1);
  date2 = new Date(date2);

  var diff = {}; // Initialisation du retour
  var tmp = date2 - date1;

  tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
  diff.sec = tmp % 60; // Extraction du nombre de secondes

  tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
  diff.min = tmp % 60; // Extraction du nombre de minutes

  tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
  diff.hour = tmp % 24; // Extraction du nombre d'heures

  tmp = Math.floor((tmp - diff.hour) / 24); // Nombre de jours restants
  diff.day = tmp;

  return diff;
}
